import styled from "styled-components"
import { FC, useEffect, useMemo, useState } from "react"
import FixtureCard from "./FixtureCard"
import Dropdown from '../../common/Dropdown';
import { useLeague } from "../../../context/useLeague"
import { Team } from "../../../models/team"

const Fixtures: FC = ({ }) => {
  const { league, userTeam } = useLeague();
  
  // Data
  const initialTeam: Team | null = userTeam ? { // Converting TeamSingle to Team
    ...userTeam,
    roster: userTeam.roster.map(user => user._id),
    managerId: userTeam.managerId._id
  } : null;

  const [team, setTeam] = useState<Team | null>(initialTeam);

  const teamOptions = useMemo(() => {
    if (!league) return [];
    return league.teams.map(team => ({ label: team.name, value: team }));
  }, [league]);

  const filteredFixtures = useMemo(() => {
    if (!team || !league) return [];
    return league.fixtures.filter(fixture => 
      fixture.home === team.name || fixture.away === team.name);
  }, [league, team]);

  // Methods
  const handleSelectTeam = (selectedOption: any) => {
    setTeam(selectedOption.value);
  };

  // Hooks 
  useEffect(() => {

  }, [])

  return (
    <>
      {/* dropdown menu */}
      <div className="container mb-3 d-flex flex-column justify-content-center align-items-center w-100">
      {/* Dropdown menu */}
      <div className="ms-1 mb-3 w-100 d-flex justify-content-center">
          <div style={{ maxWidth: "320px", width: "100%" }}>
          {league ?
          <Dropdown
            options={teamOptions}
            text={"Select team..."}
            onSelect={handleSelectTeam}
              />
          : null}
        </div>
      </div>
      {/* Fixture cards */}
      <GridContainer className="row w-100">
          {team ?
            filteredFixtures.map((fixture) => (
          <div className="col-lg-4 col-md-6 col-12" key={fixture._id}>
            <FixtureCard fixture={fixture} team={team} />
          </div>
        )) : null}
      </GridContainer>
    </div>
    </>
  )
}

export default Fixtures

const GridContainer = styled.div``
